<template lang="pug">
div
  simple-table(v-if="lead")
    tbody
      tr
        th Company
        td {{ lead.company_name }}
      tr
        th Email
        td
          ClickToCopy(:text="lead.email", v-if="lead.email")
      tr
        th Phone
        td
          ClickToCopy(:text="lead.phone | phone", v-if="lead.phone")
      tr
        th Size
        td {{ lead.size }}
      tr
        th Tags
        td
          Tags(:tags="lead.tags")
      tr
        th Address
        td {{ lead.address | address }}
      tr
        th Notes
        td {{ lead.notes }}
      tr
        th Status
        td {{ lead.status }}
      tr
        th Last Update
        td {{ lead.updated | date }}
      tr
        th Created
        td {{ lead.created | date }}
  div(v-if="contact")
    v-subheader Contact
    simple-table
      tbody
        tr
          th Name
          td {{ contact.first_name }} {{ contact.last_name }}
        tr
          th Email
          td
            ClickToCopy(:text="contact.email", v-if="contact.email")
        tr
          th Phone
          td
            ClickToCopy(:text="contact.phone | phone", v-if="contact.phone")
</template>

<script>
import { mapGetters } from "vuex";
import Tags from "/libs/components/Dev/Issue/Tags";

export default {
  components: { Tags },
  props: {
    lead: { type: Object, default: () => ({}) },
  },
  computed: {
    ...mapGetters(["salesOrganization"]),
    ...mapGetters("crm", ["contacts"]),
    contact() {
      return this.contacts.find((c) => c._id === this.lead.contact);
    },
  },
  async mounted() {
    if (!this.contacts.length) await this.loadContacts();
  },
  methods: {
    async loadContacts() {
      const organization = this.salesOrganization?._id;
      if (!organization) return;
      try {
        const criteria = { organization };
        const contacts = await this.$api.crm.contact.list({ criteria });
        this.$store.dispatch("crm/setContacts", contacts);
      } catch (e) {
        this.$toast.error(e.response?.data || "Failed to load contacts");
      }
    },
  },
};
</script>